<template>
  <div>
    <div class="page-head">
      <div>
        <h1 class="page-title">Roles</h1>
        <p class="page-sub">Perfiles de permisos para los usuarios</p>
      </div>
      <div class="page-actions">
        <b-button type="is-primary" icon-left="plus" @click="$router.push('/roles/crear')">Nuevo rol</b-button>
      </div>
    </div>

    <section class="section" style="padding-top:0">
      <div class="box">
        <table class="table is-fullwidth">
          <thead>
            <tr>
              <th>ID</th>
              <th>Nombre</th>
              <th>Descripción</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="r in roles" :key="r.id">
              <td>{{ r.id }}</td>
              <td>{{ r.nombre }}</td>
              <td>{{ r.descripcion }}</td>
              <td>
                <b-button size="is-small" type="is-info is-light" icon-left="pencil" @click="editar(r.id)">Editar</b-button>
                <b-button size="is-small" type="is-danger is-light" icon-left="delete" @click="eliminar(r.id)">Eliminar</b-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</template>

<script>
import HttpService from '@/Servicios/HttpService'
export default{
  name: 'RolesList',
  data:()=>({ roles: [] }),
  mounted(){ this.cargar() },
  methods:{
    async cargar(){
      const payload = { accion: 'obtener' }
      this.roles = await HttpService.registrar('roles.php', payload)
    },
    editar(id){ this.$router.push(`/roles/editar/${id}`) },
    async eliminar(id){
      if(!confirm('Eliminar rol?')) return;
      await HttpService.registrar('roles.php',{ accion:'eliminar', id })
      this.cargar();
    }
  }
}
</script>
